module.exports = __webpack_public_path__ + "static/media/circle_spinner.25ef2804.gif";